import React from 'react';
import './css/ImagesPage.css';
import UploadDiskImage from '../components/UploadDiskImage';
import NextButton from '../components/NextButton';
import { useImageContext } from '../contexts/ImageContext';
import defaultSpinningDisk from '../images/defaultSpinningDisk.jpg';

function ImagesPage() {
  const { uploadedImage, imageName } = useImageContext();
  
  // Check if a real image has been uploaded (not the default)
  const hasUploadedImage = uploadedImage && 
    (uploadedImage !== defaultSpinningDisk && 
     !uploadedImage.includes('defaultSpinningDisk') &&
     (uploadedImage.startsWith('data:') || imageName !== 'example.jpg'));

  return (
    <div className="images-page">
      <div className="images-container">
        <UploadDiskImage />
        <div className="page-navigation">
          <NextButton 
            nextPath="/colours" 
            disabled={!hasUploadedImage}
            text="Choose Colors"
          />
        </div>
      </div>
    </div>
  );
}

export default ImagesPage;